module.exports = __webpack_public_path__ + "static/media/keyboard_arrow_down.2fb63a56.svg";